import { useMemo } from 'react'

import {
  ProductCatalogEmbroideryLocation,
  ProductCatalogEmbroideryPlacement,
  ProductCatalogEmbroideryPosition,
  ProductCatalogEmbroideryTypes,
} from '../../__generated__/graphql/catalog/graphql'
import { useEmbroidery } from '../../containers/EmbroideryContainer/EmbroideryProvider'
import { getEmbroideryTypeForEmbroideryForm } from '../../containers/EmbroideryContainer/utils/embroideryFormUtils'
import { getEmbroideryPlacementKey } from '../../containers/EmbroideryContainer/utils/getEmbroideryPlacementKey'

type EmbroideryPlacementKey =
  `${ProductCatalogEmbroideryLocation}:${ProductCatalogEmbroideryPosition}`

export const legacyEmbroideryWorkflowBlockedPlacements = {
  TEXT: ['SLEEVE:LEFT', 'SLEEVE:RIGHT'],
  ICON: ['SLEEVE:RIGHT', 'CHEST:LEFT', 'CHEST:RIGHT'],
  LOGO: ['SLEEVE:LEFT', 'SLEEVE:RIGHT'],
} as const satisfies Record<ProductCatalogEmbroideryTypes, readonly EmbroideryPlacementKey[]>

// Filter based on blocked placements
// Temporary fix while multiplacement is behind a feature flag
// Cleanup ticket: LFE-150
export const useValidPlacementOptionsForLegacyFlow = (
  placementOptions: ProductCatalogEmbroideryPlacement[] | null | undefined
): ProductCatalogEmbroideryPlacement[] | null | undefined => {
  const { selectedFormKind } = useEmbroidery()

  return useMemo(() => {
    if (!placementOptions || !selectedFormKind) return placementOptions

    const embroideryType = getEmbroideryTypeForEmbroideryForm(selectedFormKind)
    const blockedPlacements = new Set<string>(
      legacyEmbroideryWorkflowBlockedPlacements[embroideryType]
    )

    const validPlacementOptions = placementOptions.filter(
      placement => !blockedPlacements.has(getEmbroideryPlacementKey(placement))
    )

    return validPlacementOptions.length > 0 ? validPlacementOptions : null
  }, [placementOptions, selectedFormKind])
}
